import { setInterval } from "core-js/library/web/timers";
import videojs from "video.js";
import tools from "tools";
import css from "./style.css";

let containerDropdownElement;
let init = false;
let levels = [
  {
    name: "auto",
    level: -1,
  },
];

const registerPlugin = videojs.registerPlugin || videojs.plugin;

/**
 * show or hide the dropdown
 */
const onToggleDropdown = () => {
  if (containerDropdownElement.className.indexOf("show") === -1) {
    containerDropdownElement.className += " show";
  } else {
    containerDropdownElement.className = containerDropdownElement.className.replace(
      " show",
      "",
    );
  }
};

/**
 * event on selected the quality
 */
const onQualitySelect = (player, quality) => {
  if (quality.name !== "auto") {
    player.tech_.hls.loadLevel = quality.level;
    player.tech_.hls.currentLevel = quality.level;
  } else player.tech_.hls.currentLevel = -1;

  const listLink = document.getElementsByClassName("vjs-quality-link");
  [...listLink].forEach((e, i) => {
    try {
      listLink[i].style.fontWeight = "400";
      let remClass = listLink[i].className;
      const re = new RegExp("(^| )selected( |$)");
      remClass = remClass.replace(re, "$1");
      remClass = remClass.replace(/ $/, "");
      listLink[i].className = remClass;
    } catch (error) {
      console.log(error);
    }
  });
  const linkEl = document.getElementsByClassName(quality.name)[0];
  linkEl.style.fontWeight = "700";
  linkEl.className += " selected";

  onToggleDropdown();
};

const onPlayerReady = player => {
  if (!init) {
    tools.addCSS("quality-selection", css);
  }
  // player.tech_.hls.currentLevel = 2;
  // player.tech_.hls.loadLevel = 2;

  tools.removeDIV(".vjs-quality-container");

  containerDropdownElement = document.createElement("div");
  containerDropdownElement.className = "vjs-quality-dropdown";

  const containerElement = document.createElement("div");
  containerElement.className = "vjs-quality-container ";

  const buttonElement = document.createElement("button");
  buttonElement.className =
    "vjs-brand-quality-link vjs-icon-cog vjs-control vjs-button";
  buttonElement.onclick = onToggleDropdown;

  setInterval(() => {
    if (
      player.el().className.indexOf("vjs-user-inactive") > -1 &&
      containerDropdownElement.className.indexOf("show") > -1
    ) {
      containerDropdownElement.className = containerDropdownElement.className.replace(
        " show",
        "",
      );
    }
  }, 500);

  const ulElement = document.createElement("ul");

  levels = [
    ...levels,
    ...player.tech_.hls.levels
      .map((e, i) => ({
        ...e,
        name: e.height ? `${e.height}p` : e.bitrate,
        level: e.level ? e.level : i,
      }))
      .sort((a, b) => {
        if (a.bitrate > b.bitrate) {
          return -1;
        } else if (a.bitrate < b.bitrate) {
          return 1;
        }
        return 0;
      }),
  ].forEach((e, i, arr) => {
    if (arr[i - 1] && arr[i - 1].height === e.height) return;

    const liElement = document.createElement("li");
    const linkElement = document.createElement("a");
    linkElement.className = `vjs-quality-link ${e.name}`;
    linkElement.innerText = e.name;
    linkElement.style.cursor = "pointer";
    linkElement.addEventListener("click", () => {
      onQualitySelect(player, e);
    });

    liElement.appendChild(linkElement);
    ulElement.appendChild(liElement);
  });

  containerDropdownElement.appendChild(ulElement);
  containerElement.appendChild(containerDropdownElement);
  containerElement.appendChild(buttonElement);

  player.controlBar
    .el()
    .insertBefore(containerElement, player.controlBar.fullscreenToggle.el());

  player.addClass("vjs-qualityselector");

  const linkEl = document.getElementsByClassName("auto")[0];
  linkEl.style.fontWeight = "700";
  linkEl.className += " selected";

  if (!init) {
    window.addEventListener("click", e => {
      if (
        e.target.className !== buttonElement.className &&
        containerDropdownElement.className.indexOf("show") >= 0
      ) {
        containerDropdownElement.className = containerDropdownElement.className.replace(
          " show",
          "",
        );
      }
    });
  }

  init = true;
};

/**
 * A video.js/hls.js plugin.
 *
 */
const qualityselection = function() {
  this.one("timeupdate", () => {
    let i = 0;
    const retry = setInterval(() => {
      if (this.tech_.hls.levels) {
        onPlayerReady(this);
        clearInterval(retry);
      }
      i += 1;
      if (i === 5) {
        console.log("no levels detected");
        clearInterval(retry);
      }
    }, 400);
  });
};

registerPlugin("qualitySelection", qualityselection);

// Include the version number.
qualityselection.VERSION = "0.8";

export default qualityselection;



// WEBPACK FOOTER //
// ./src/js/videoJSExtensions/quality-selection/hlsjs-quality-button.js